import Vue from 'vue'

const resource = 'meeting-categories'

const getAll = (params = {}) => Vue.axios(`${resource}`, {params})

export default {
  getAll
}



// WEBPACK FOOTER //
// ./src/api/meeting-categories.js